import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

export default function ClientPageHeader({ title }) {
  const navigate = useNavigate();

  return (
    <header className="bg-background px-6 pt-4 pb-3">
      <div className="hidden md:flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-black text-lg font-semibold focus:outline-none"
        >
          <FaArrowLeft className="text-gray-700 text-lg" />
        </button>
        <span className="text-2xl font-semibold text-foreground">{title}</span>
      </div>
    </header>
  );
}
